export let sessionTimeoutSeconds
export let sessionTimeoutWarningSeconds

export function configureSessionTimeout(options) {
  sessionTimeoutSeconds =
    options.sessionTimeoutSeconds || window.$appConfig.VUE_APP_SESSION_TIMEOUT_SEC
  sessionTimeoutWarningSeconds =
    options.sessionTimeoutWarningSeconds || window.$appConfig.VUE_APP_SESSION_TIMEOUT_WARN_SEC
}
